import styled from '@emotion/styled';

export const Logo = styled.img`
  margin-left: -20px;
  margin-top: -30px;
  width: 200px;
  height: auto;

  @media (min-width: 768px) {
    margin-left: 0;
    width: 300px;
  }

  @media (min-width: 1300px) {
    margin-left: -100px;
    width: 512px;
  }
`;
